var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('h1',[_vm._v("Abmelden")]),_c('p',[_vm._v("Sie wurden erfolgreich abgemeldet.")]),_c('b-button',{attrs:{"variant":"primary"},on:{"click":_vm.login}},[_vm._v("erneut anmelden")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }